import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AttendanceReportsComponent } from './attendance-reports.component';
import { EditAttendanceReportsComponent } from './components/edit-attendance-reports/edit-attendance-reports.component';
import { AuditPermissionsComponent } from './components/audit-permissions/audit-permissions.component';

const routes: Routes = [
  {
    path: '',
    component: AttendanceReportsComponent
  },
  {
    path: 'editar/:id',
    title: 'Editar Atendimento',
    component: EditAttendanceReportsComponent,
  },
  {
    path: 'permissoes',
    title: 'Revisão de Permissões',
    component: AuditPermissionsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendanceReportsRoutingModule { }